import React, { useState, useEffect } from "react";
import ReactTableComponent from "../UniversalComponents/ReactTableComponent";
import { Dialog } from "@mui/material";
import { useLazyGetFieldsValueQuery } from "../../utils/customer/customerSelect";
import DynamicVoucherForm from "./DynamicVoucher";
import LayoutHOC from "../LayoutHOC";
import FileAttachment from "../UniversalComponents/FileAttachment";
import AutofillBill from "./AutofillBill";
import Button from "../UniversalComponents/DefaultButton";

const additionalText = (
  <div className="text-xs text-[#AFAFAF] font-normal">
    <p>Supported formats: PDF, PNG, JPEG</p>
    {/* <p>Upload your document Maximum Size 10 MB</p> */}
  </div>
);

const apiBaseUrl = "https://fin-txn-classify.azurewebsites.net/upload_pdf";

const FileUploader = () => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");

  const supportedFormats = [
    "application/pdf",
    "image/png",
    "image/jpeg",
    "application/vnd.ms-excel", // .xls
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    "text/csv", // .csv
  ];

  // Handle file selection from input
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (supportedFormats.includes(selectedFile.type)) {
        setFile(selectedFile);
        setError("");
      } else {
        setError("Unsupported file format. Only PDF, PNG, and JPEG are allowed.");
      }
    }
  };

  // Handle file drop
  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile) {
      if (supportedFormats.includes(droppedFile.type)) {
        setFile(droppedFile);
        setError("");
      } else {
        setError("Unsupported file format. Only PDF, PNG, and JPEG are allowed.");
      }
    }
  };

  const handlePost = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch(apiBaseUrl, {
        method: "POST",
        headers: {
          // Authorization: `Bearer ${user?.token}`,
          "Content-Type": "multipart/form-data",
        },
        body: formData,
      });
      const data = await response.json();

      console.log("data AI", data);
    } catch (error) {
      alert("API integration is under development");
    }
  };

  // Prevent default behavior for drag events
  const handleDragOver = (event) => {
    event.preventDefault();
  };

  return (
    <div className="w-full mx-auto p-6 bg-white rounded-lg">
      <h2 className="text-lg font-semibold mb-6">Auto fill</h2>

      {/* Upload method dropdown */}
      <div className="mb-4">
        <div className="w-full py-2 text-lg rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
          Upload from this device
        </div>
      </div>

      {/* Drag and drop area */}
      <div
        className="border-2 border-dashed border-gray-300 rounded-md p-6 text-center mb-4 cursor-pointer"
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={() => document.getElementById("fileInput").click()} // Trigger file input on click
      >
        {file ? (
          <p className="text-sm text-gray-700">
            Selected File: <span className="font-medium">{file.name}</span>
          </p>
        ) : (
          <div>
            <p className="text-sm text-gray-600 mb-2">Or Drag And Drop Here</p>
            <p className="text-xs text-gray-500">supported formats: PDF, PNG, JPEG</p>
          </div>
        )}
      </div>

      {/* Hidden file input */}
      <input
        id="fileInput"
        type="file"
        className="hidden"
        onChange={handleFileChange}
        accept=".pdf, .png, .jpeg, .xls, .xlsx, .csv"
      />

      {/* Autofill button */}
      <div className="text-center mb-6">
        <button
          type="button"
          className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition"
          onClick={() => document.getElementById("fileInput").click()}
        >
          Autofill From File <span className="ml-1">▼</span>
        </button>
      </div>

      {/* Error message */}
      {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

      {/* Action buttons */}
      <div className="flex justify-between">
        <button
          type="button"
          className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition"
          onClick={() => {
            setFile(null);
            setError("");
          }}
        >
          Cancel
        </button>
        <button
          type="button"
          className={`px-4 py-2 text-white rounded-md transition ${
            file ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-400 cursor-not-allowed"
          }`}
          disabled={!file}
          onClick={() => handlePost(file)}
        >
          Save
        </button>
      </div>
    </div>
  );
};

// export default FileUploader;

const BankTransfer = ({ voucher, tokens }) => {
  const [showCreateVoucher, setShowCreateVoucher] = useState(false);

  const [file, setFile] = useState([]);

  const handleOpenUpload = () => {
    // console.log("praveen kkko", voucher, tokens )
    // getFieldsValue({
    //   tokens,
    //   voucherId: voucher.id,
    // })
    setShowCreateVoucher(true);
  };

  const [getFieldsValue, { data: formConfig }] = useLazyGetFieldsValueQuery();

  // useEffect(() => {

  //   console.log("praveen kkko", voucher, tokens )
  //   getFieldsValue({
  //     tokens,
  //     voucherId: voucher.id,
  //   })
  // }, []);

  const handleUpload = () => {
    console.log("upload praveen", file);
  };
  return (
    <div className={`p-4`}>
      {/* {voucher.name} */}

      <ReactTableComponent
        tablename="Bank Transfer"
        // headers = {{}}
        body={[{ id: 1, name: "Dummy Row", date: "2023-01-01" }]}
        actionColumn={<div>Action</div>}
        actionField={
          <div
            className="bg-white p-2 border-y-2-[#335678] rounded-lg cursor-pointer"
            onClick={() => handleOpenUpload()}
          >
            {" "}
            AI Upload{" "}
          </div>
        }
      />

      {showCreateVoucher && (
        <Dialog open={showCreateVoucher} onClose={() => setShowCreateVoucher(false)} className="!z-[10000]" fullWidth>
          <div className="text-right mr-2 mt-2">
            <i className="bi bi-x hover:text-red-400 text-2xl" onClick={() => setShowCreateVoucher(false)}></i>
          </div>
          {/* <div className="flex flex-col items-center py-5">
            <FileAttachment
              onChange={(file) => setFile(file)}
              maxSize={10}
              label="Upload your document"
              id={"AiFileUpload"}
              name={"AiFileUpload"}
              value={file || []}
              error={""}
              additionalText={additionalText}
            />
            <Button
              varia="secondary"
              onClick={handleUpload}
              style={{
                backgroundColor: "#1D4469",
                borderColor: "#123251",
                color: "#fff",
                height: "35px",
                fontSize: "12px",
                display: "flex",
                gap: "8px",
                alignItems: "center",
              }}
            >
              Upload
            </Button>
          </div> */}
          <FileUploader />
        </Dialog>
      )}
    </div>
  );
};

export default LayoutHOC(BankTransfer);
